import { MotivationPartialData } from "src/app/all-motivations/model/all-motivations.interface";
import { UserMicroData_PulseDataExtended } from "../personal-user-data/personal-user-data";
import { UserResponsePresentationDataTypeEnum } from "./response.enum";

export interface UserResponsePresentationData{
    id: string;
    header: string;
    subHeader: string;
    text: string;
    image: string;
    engagementType: UserResponsePresentationDataTypeEnum;
    isFirstTime: boolean;
    userId: string;
    orgId: string;
    mailAddress: string;
    returnUrl: string;
}

export interface PulseCheckRequiredData{
    userMicroData: UserMicroData_PulseDataExtended;
    drivers: MotivationPartialData[];
    frequency: PulsecheckFrquencyProfileEnum;
}

export enum PulsecheckFrquencyProfileEnum {
    MONTHLY = 1,
    WEEKLY = 2
}

export interface PendingPulseCheckData {
    hasPendingPulseCheck: boolean;
    token: string | null;
}